import React from 'react';

import { ContentCellData } from '@/libraries/design/patterns/pricing-table/src/cell-variants/types';

import {
	CellTextContent,
	CellCheckContent,
	CellExpanderContent,
	CellHyperlinkContent,
	CellRenderContent,
} from '../cell-variants/cell-variants';

interface ContentCellProps {
	cellData: ContentCellData;
	isRowHeader?: boolean;
}

export const ContentCell: React.FC<ContentCellProps> = (props: ContentCellProps) => {
	const { cellData, isRowHeader } = props;

	if (cellData === null) {
		return null;
	}

	switch (cellData.type) {
		case 'text':
			return <CellTextContent data={cellData} isRowHeader={isRowHeader} />;
		case 'check':
			return <CellCheckContent />;
		case 'expander':
			return <CellExpanderContent data={cellData} />;
		case 'hyperlink':
			return <CellHyperlinkContent data={cellData} />;
		case 'render':
			return <CellRenderContent data={cellData} />;
		default:
			return null;
	}
};
